import { useInfiniteQuery, useQuery } from "react-query";

import { popular_store_api } from "../../../ApiRoutes";
import MainApi from "../../../MainApi";
import { onErrorResponse } from "../../../api-error-response/ErrorResponses";

const getPopularStore = async (type) => {
  const { data } = await MainApi.get(`${popular_store_api}?type=${type}`);
  return data;
};
const getPopularStoreInfiniteScroll = async (pageParams) => {
  const { type, limit, pageParam } = pageParams;
  const { data } = await MainApi.get(
    `${popular_store_api}?type=${type}&offset=${pageParam}&limit=${limit}`
  );
  return data;
};

export default function useGetPopularStore(pageParams) {
  return useInfiniteQuery(
    [pageParams?.searchKey, pageParams?.type],
    ({ pageParam = 1 }) =>
      getPopularStoreInfiniteScroll({ ...pageParams, pageParam }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.stores?.length > 0 ? nextPage : undefined;
      },
      retry: 1,
      enabled: false,
      onError: onErrorResponse,
    }
  );
}

export function useGetPopularStoreWithoutInfiniteScroll(pageParams) {
  return useQuery(
    [pageParams?.queryKey || 'popular-stores', pageParams?.type],
    () => getPopularStore(pageParams?.type),
    {
      enabled: true, // Enable automatic query execution
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      onError: onErrorResponse,
    }
  );
}
